import { render, staticRenderFns } from "./RichControl.vue?vue&type=template&id=c2955d14&scoped=true&"
import script from "./RichControl.vue?vue&type=script&lang=js&"
export * from "./RichControl.vue?vue&type=script&lang=js&"
import style0 from "./RichControl.vue?vue&type=style&index=0&id=c2955d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2955d14",
  null
  
)

export default component.exports